const opts = {
  filterable: false,
  sortable: false
};
export default {
  id: 'locator.beaconsList',
  name: 'locator.beaconsList',
  displayName: 'Beacons List',
  valueType: 'string',
  objectType: 'locator',
  blueprint: {},
  getOption: key => {
    return opts[key];
  },
  get: obj => {
    const toReturn = [];
    const lastPayload = JSON.parse(obj?.data?.lastPayload || null);
    const beaconsList = lastPayload?.report?.position?.beaconsList;
    if (beaconsList) {
      toReturn.push(beaconsList);
    }
    return toReturn;
  }
};